<template>
    <div class="row">
        <div class="col-md-12 card-wrapper">
            <div class="card">
                <div class="card-header crm-modal-header hpx-50 d-flex align-items-center">{{$ml.get('EDIT_PERSONAL_SETTINGS')}}</div>
                <div class="card-body bg-light color-gray">
                    <div class="row">
                        <div class="col-md-6">
                            <div>
                                <label class="new-label">{{$ml.get('NAME')}}</label>
                                <input type="text" v-model="name" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">{{$ml.get('SURNAME')}}</label>
                                <input type="text" v-model="surName" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">{{$ml.get('GSM_NO')}}</label>
                                <input type="number" v-model="gsm" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">{{$ml.get('E_MAIL')}}</label>
                                <input type="text" id="email" v-model="email" disabled="disabled" class="new-input" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div>
                                <label class="new-label">{{$ml.get('CO_NAME')}}</label>
                                <input type="text" v-model="companyName" disabled="disabled" class="new-input" />
                            </div>
                            <div>
                                <label class="new-label">{{$ml.get('TIMEZONE')}}
                                    <v-popover class="d-inline-block" style="cursor:pointer;">
                                    <i class="fa fa-info-circle tooltip-target b3" ></i>
                                        <template #popover>
                                            <p><i class="fa fa-info-circle fa-3x"></i></p>
                                            <p>
                                            {{$ml.get('PERSON_TIMEZONE_INFO')}}
                                            </p>

                                            <a v-close-popover class="btn bg-new-primary text-white">{{$ml.get('COMPLETE')}}</a>
                                        </template>
                                    </v-popover>
                                </label>
                                <select v-model="timeZone" class="new-input">
                                    <option v-for="(timezone,index) in timezones" :key="index" :value="timezone">{{timezone}}</option>
                                </select>
                            </div>
                            <div>
                                <label class="new-label">{{$ml.get('LANGUAGE')}}</label>
                                <select v-model="language" class="new-input">
                                    <option v-for="(language,index) in languages" :key="index" :value="language.code">{{$ml.get(language.label)}}</option>
                                </select>
                            </div>
                        </div>
                    </div>



                </div>
                <div class="card-footer text-right crm-modal-footer">
                    <button class="btn " @click="resetForm()">{{$ml.get('CANCEL')}}</button>
                    <button class="btn bg-new-primary w-150p " @click="updateUserSettingsF()">{{$ml.get('SAVE')}}</button>
                </div>



            </div>
        </div>
        <notifications group="foo" style="margin-right:5%;margin-top:5%" position="top right" />
    </div>
</template>
<script>
import { mapState,mapGetters,mapActions } from 'vuex'
export default {
    name:'editPersonalSettings',
    data() {
        return {
            name:'',
            surName:'',
            gsm:'',
            email:'',
            companyName:'',
            timeZone:'Etc/UTC',
            language:localStorage.getItem('vueml-lang'),
            languages:[{'code':'tr','label':'TURKISH'},{'code':'en','label':'ENGLISH'}],
            selected: '',
            picked: null
        }
    },
    computed: {
        ...mapState(['timezones']),
        ...mapGetters(['user_settings'])
    },
    methods: {
        ...mapActions(['getUserSettings','updateUserSettings', 'setUserName']),
        setFormData(){
            console.log('User settings alanı')
            console.log(this.user_settings)
            this.name = this.user_settings.name
            this.surName = this.user_settings.surName
            this.gsm = this.user_settings.gsm
            this.email = this.user_settings.email
            this.companyName = this.user_settings.company.name
            this.timeZone = this.user_settings.timeZone
            if(this.user_settings.language){
                this.language = this.user_settings.language
            }
            
        },
        resetForm(){
            this.setFormData()
        },
        updateUserSettingsF(){
            let form = {}


            if(this.name === ''){
                this.$notify({ 
                    group: 'foo',
                    type: 'warn', 
                    title: 'İsim girilmeli'
                })
                return false
            }else{
                form.name= this.name
            }
            // if(this.surName!=''){
                 form.surName= this.surName
            // }
            // if(this.gsm!=''){
                 form.phone= this.gsm
            // }
            // if(this.timeZone!=''){
                 form.timeZone= this.timeZone
            // }
            // if(this.language!=''){
                 form.language= this.language
            // }

            
            this.updateUserSettings(form).then((res)=>{return res}).then((res)=>{
                if(res.data.status.code==0){
                    this.$notify({ 
                        group: 'foo',
                        type: 'success', 
                        title: this.$ml.get('SUCCESSFUL'),
                        text: res.data.status.desc 
                    })
                    this.getUserSettings().then((res)=>{ return res}).then((res)=>{
                        this.setFormData()
                    }) 
                    if(res.data.content.user.language){
                        this.$ml.change(res.data.content.user.language);
                    }
                    localStorage.setItem('name', res.data.content.user.name)
                    localStorage.setItem('surname', res.data.content.user.surName)
                    this.setUserName()
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                }
            })
        }
        
    },
    created() {
        this.getUserSettings().then((res)=>{ return res}).then((res)=>{
            this.setFormData()
        })  

        
    },
}
</script>
